<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
                slider1: false,
                slider2: false
            }
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        watch: {
            step: function (val) {
                if (val > 5) {
                    this.slider1 = true
                    this.slider2 = true
                }

                switch (val) {
                    case 2:
                        $('html, body').animate({scrollTop: $('#js-introduce-sound-spelling').position().top + 100}, 'slow')
                        break
                    case 5:
                        $('html, body').animate({scrollTop: $('.js-show-guides').position().top + 500}, 'slow')
                        break
                    case 6:
                        $('html, body').animate({scrollTop: $('.js-guide-1').position().top + 800}, 'slow')
                        break
                    case 7:
                        $('html, body').animate({scrollTop: $('.js-page-top').position().top}, 'slow')
                        break
                }
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        computed: {
            introduceSoundSpellingPanelVisible() {
                return this.step > 1
            },
            mainMenuVisible() {
                return this.step > 8
            },
            mainMenuStyleObject() {
                if (this.step > 8) {
                    return {
                        'z-index': 100
                    }
                } else {
                    return {
                        'left': '143px',
                        'z-index': 0
                    }
                }
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 9) {
                    window.location = '05.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            },
            goToIntro() {
                window.location = 'intro.html'
            },
            guidesClicked() {
                if (this.step == 5 && this.slider1 && this.slider2) {
                    this.nextStep()
                }
            },
            hamburgerIconClicked() {
                if (this.step == 8) {
                    this.nextStep()
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-04.vue